import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { FuseSharedModule } from "@fuse/shared.module";

import { AsapMaterialModule } from "../../../../material-module";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { MatButtonModule } from "@angular/material/button";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRippleModule } from "@angular/material/core";
import { MatSortModule } from "@angular/material/sort";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { FuseWidgetModule } from "../../../../../@fuse/components";
import { AgmCoreModule } from "@agm/core";
import { MatSelectModule } from "@angular/material/select";
import { BaseListService } from "../../base/base-list.service";
import { StatusService } from "../status/status.service";
import { MatChipsModule } from "@angular/material/chips";
import { SharedModule } from "../../common/shared.module";
import { AuthGuard } from "../../auth/auth.guard";
import { TicketsListComponent } from "./tickets-list/tickets-list.component";
import { TicketsService } from "./tickets.service";
import { AddTicketsComponent } from './add-tickets/add-tickets.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { EditTicketComponent } from './edit-ticket/edit-ticket.component';
import { TicketDetailsComponent } from './ticket-details/ticket-details.component';
import { TableRefreshService } from "./table-refresh.service";
import { AttachmentDialogComponent } from './attachment-dialog/attachment-dialog.component';
import { CommentsDialogComponent } from './comments-dialog/comments-dialog.component';
import { SignatureDialogComponent } from './signature-dialog/signature-dialog.component';

const routes = [
    {
        path: "tickets/tickets-list",
        component: TicketsListComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "tickets/ticket-details",
        component: TicketDetailsComponent,
        canActivate: [AuthGuard],
    }
];

@NgModule({
    declarations: [
     TicketsListComponent,
     AddTicketsComponent,
     EditTicketComponent,
     TicketDetailsComponent,
     AttachmentDialogComponent,
     CommentsDialogComponent,
     SignatureDialogComponent   
    ],
    imports: [
        RouterModule.forChild(routes),
        TranslateModule,
        FuseSharedModule,
        AsapMaterialModule,
        NgxDaterangepickerMd,
        SharedModule,
        MatTableModule,
        MatButtonModule,
        MatChipsModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatPaginatorModule,
        MatRippleModule,
        MatSelectModule,
        MatSortModule,
        MatSnackBarModule,
        MatTabsModule,

        NgxChartsModule,
        AgmCoreModule.forRoot({
            apiKey: "AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8",
        }),

        FuseSharedModule,
        FuseWidgetModule,
        // NgxQRCodeModule
        TranslateModule,
        SignaturePadModule
    ],
    entryComponents: [
        AddTicketsComponent,
        EditTicketComponent
    ],
    exports: [
        TicketsListComponent,
        AddTicketsComponent,
        EditTicketComponent,
        TicketDetailsComponent
    ],
    providers: [
        StatusService,
        TicketsService,
        TableRefreshService
    ],
})
export class TicketModule {}
